import { Injectable } from '@angular/core';
import { OrderItemStatusEnum } from '../../enum/status/order-item-status.enum';
import { OrderStatusEnum } from '../../enum/status/order-status.enum';
import { SaleChannelEnum } from '../../enum/type/sale-channel.enum';
import { UnitEnum } from '../../enum/unit.enum';
import { OrderItemDetailView } from '../../models/dto/orderItemDetailView';
import { ProductPriceTabDto } from '../../models/dto/productPriceTabDto';
import { ProductPriceView } from '../../models/dto/productPriceView';
import { OrderEntity } from '../../models/entity/order/order.entity';
import { OrderItemEntity } from '../../models/entity/order/order-item.entity';
import { OrderItemDetailEntity } from '../../models/entity/order/order-item-detail.entity';
import { StoreSettingEntity } from '../../models/entity/store/store-setting.entity';
import { DateUtils } from '../../utils/date.utils';
import { NumberUtils } from '../../utils/number.utils';
import { OrderItemWithDetailDto } from '../../models/dto/orderItemWithDetailDto';

@Injectable({
  providedIn: 'root'
})
export class OrderUtilsService {

  constructor() {
  }


  addOrderItem(selectedProduct: ProductPriceTabDto,
    quantity: number, numberOfUnits: number, orderId: number, storeSetting: StoreSettingEntity) {

    let orderItem = new OrderItemEntity();

    orderItem.orderId = orderId;
    orderItem.productId = selectedProduct.productId;
    orderItem.quantity = quantity;
    orderItem.numberOfUnits = numberOfUnits;
    orderItem.unitId = selectedProduct.unitId;

    if (selectedProduct.isAutoDelivery)
      orderItem.orderItemStatusId = OrderItemStatusEnum.DELIVERED;
    else if (selectedProduct.isRetail)
      orderItem.orderItemStatusId = OrderItemStatusEnum.READY;
    else
      orderItem.orderItemStatusId = OrderItemStatusEnum.PREPARATION;

    if (orderItem.unitId == UnitEnum.SQUARE_METERS) {
      orderItem.isRequiredApprove = storeSetting.isRequiredApproveForSquareMeter;
    }

    return orderItem;
  }

  addOrderItemDetail(orderItem: OrderItemEntity, price: ProductPriceView, isAvailableForDispatch: boolean) {
    if (NumberUtils.isNotGreaterThanZero(orderItem.hangerTypeId) &&
      NumberUtils.isGreaterThanZero(price.hangerTypeId)) {
      orderItem.hangerTypeId = price.hangerTypeId;
      orderItem.hangerPrice = price.hangerPrice;
    }

    let orderItemDetail = new OrderItemDetailEntity();

    // orderItemDetail.orderItemId = orderItem.id;
    orderItemDetail.orderItemTypeId = price.orderItemTypeId;
    orderItemDetail.priceOrginal = price.price;
    orderItemDetail.priceScreen = price.price;
    orderItemDetail.status = orderItem!.orderItemStatusId;
    orderItemDetail.isAvailableDiscount = price.isAvailableDiscountFinal;
    orderItemDetail.isAvailableForDispatch = isAvailableForDispatch;
    orderItemDetail.currencyCode = price.currencyCode;

    let orderItemDetailView = new OrderItemDetailView();
    orderItemDetailView.orderItemDetail = orderItemDetail;
    orderItemDetailView.orderItemTypeName = price.orderItemTypeName;

    return orderItemDetailView;
  }

  calculateOrderItemAmounts(data: OrderItemWithDetailDto) {
    var quantityWithNumberOfUnits = (data.orderItem?.quantity ?? 1) * (data.orderItem?.numberOfUnits ?? 1);

    data.orderItemDetails!.forEach(x => {
      x.orderItemDetail!.totalAmount = x.orderItemDetail!.priceScreen! * quantityWithNumberOfUnits;
      x.orderItemDetail!.finalAmount = x.orderItemDetail!.totalAmount!;
      x.orderItemDetail!.totalDiscountAmount = 0;
    });

    data.totalAmount = data.orderItemDetails!.map((e) => quantityWithNumberOfUnits * (e.orderItemDetail?.priceScreen ?? 0)).reduce((value, element) => value + element);
    data.totalDiscountAmount = 0;
    data.finalAmount = data.totalAmount!;

  }

  createNewOrder(storeId: number, customerId: number, addressId: number, storeSetting: StoreSettingEntity) {
    let order = new OrderEntity();
    order.saleChannelId = SaleChannelEnum.WEB_APP;
    order.storeId = storeId;
    order.orderStatusId = OrderStatusEnum.ORDER_PREPARATION;
    if (storeSetting) {
      order.isPickup = storeSetting.isSelectedForPickup;
      order.isDelivery = storeSetting.isSelectedForDelivery;

    }
    order.customerId = customerId;
    order.pickupAddressId = addressId;
    order.deliveryAddressId = addressId;
    order.totalPrice = 0;
    order.totalDiscountPrice = 0;
    order.totalNetPrice = 0;
    order.discountPercentage = 0;

    return order;
  }

  calculatePickupDate(order: OrderEntity, storeSetting: StoreSettingEntity) {

    order.pickupDate = DateUtils.addMinutes(
      DateUtils.addHours(
        DateUtils.getToday(),
        new Date().getHours()
      ),
      storeSetting.durationForPickup!
    );

    order.pickupDate = DateUtils.addMinutes(order.pickupDate, 15 - (order.pickupDate.getMinutes() % 15));
  }

  calculatDeliverypDate(order: OrderEntity, storeSetting: StoreSettingEntity) {
    if (order.pickupDate == null)
      order.pickupDate = DateUtils.getNow();

    if (order.deliveryDate == null)
      order.deliveryDate = DateUtils.getNow();


    if (order.pickupDate > order.deliveryDate)
      order.deliveryDate = order.pickupDate;

    if (storeSetting.deliveryPeriodType == 1)
      order.deliveryDate = DateUtils.addDays(order.pickupDate, storeSetting.deliveryPeriodValue!);
    else if (storeSetting.deliveryPeriodType == 2)
      order.deliveryDate = DateUtils.addHours(order.pickupDate, storeSetting.deliveryPeriodValue!);


  }
}
